// extracted by mini-css-extract-plugin
export default {"hidden":"PageRoute_hidden__IL8Vj"};